export default "__VITE_ASSET__DedigazI__"